module.exports = __webpack_public_path__ + "media/a1.0f755b81.mp3";